import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { TradeReportingSec606ReportCreateDrawer } from '../../../../../../../../../../features/trade-reporting/sec-606/trade-reporting-sec-606-report-create-drawer';
import { TradeReportingSec606ReportsTable } from '../../../../../../../../../../features/trade-reporting/sec-606/trade-reporting-sec-606-reports-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/sec-606/_sec-606/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingComplianceReporting,
      label: 'SEC 606(a)',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingComplianceReporting>,
  head: () => getPageHead('SEC 606(a) Reports'),
  component: Sec606aReportList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <TradeReportingSec606ReportCreateDrawer
              trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New SEC 606(a) Report" size="small" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingComplianceReporting}
    />
  );
}

function Sec606aReportList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TradeReportingSec606ReportsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
